
export default {
    name: 'evenement',
    components: {},
    props: ["soins_evenement", "hn", "protocole_id", "can_show_empty"],
    data() {
        return {
            is_loading: true,
            is_empty: false
        }
    },

    watch: {
        soins_evenement() {
            this.getEvenement()
        }
    },

    computed: {
        
    },

    mounted() {
        this.getEvenement()
    },

    methods: {
        getEvenement() {
            this.is_loading = true
            if (this.soins_evenement.length > 0) {
                this.is_empty = false
            } else {
                this.is_empty = true
            }
            setTimeout(() => {
               this.is_loading = false 
            }, 500);
        }
    }
}


